'use strict';

var Analytics = require('./analytics');
class AnalyticsManager extends Analytics {
    init() {
        super.init($('.analytics.navigationData'), $('.analytics.helperData'));

        var screenWidth = window.screen.width;
        var screenHeight = window.screen.height;
        var orientation = window.screen.orientation || {};
        var videoWallThresholdWidth = 3840;
        var videoWallThresholdHeight = 2160;
        var isPortrait = (orientation.type === 'portrait-primary' || orientation.type === 'portrait-secondary') || (screenWidth < screenHeight);
        var isHighResolution = (screenWidth >= videoWallThresholdWidth || screenHeight >= videoWallThresholdHeight);

        this.analyticProviders = [
            require('./cartInteraction'),
            require('./checkoutFunnel'),
            require('./minicart'),
            require('./account'),
            require('./promoAndInfo'),
            require('./findYourStore'),
            require('./listing'),
            require('./refund'),
        ];

        for (let provider of this.analyticProviders) {
            provider.init(this.globalContainer, this.helperContainer);
        }

        this.pushPDPData();
        this.prepareHeaderObservers();
        this.prepareMenuObservers();
        this.preparePerfectBraObservers();
        this.prepareSearchObservers();
        this.prepareNewsletterObservers();
        this.observeWishlistChanges();
        this.handleContactUs();
        this.handleUnsubscribePhone();
        this.observeFooterChanges();
        this.observeProductChanges();
        this.prepareScalaPayObservers();
        this.prepareKlarnaObservers();
        this.prepareAfterpayObservers();
        this.observeSoldOutPopupChanges();
        this.prepareGiftcardObservers();
        this.observeContentChanges();
        this.observeOrderChanges();
        this.observeSplashPageChanges();
        this.observeMadeInClick();
        this.handleBuyGiftCard();
        this.handleSmartGift();
        this.handleVideoInteraction();
        this.handleRatingAndReviewsPdp();
        this.handleRatingAndReviewsForm();
        this.prepareNeedHelpObservers();
        this.prepareEcoChoiceObservers();
        this.prepareTrackYourOrderObservers();
        this.preparePersonalAreaNavigationOrderSectionObservers();
        this.cookiePolicyObservers();
        this.replaceTagsPrivacyConsentModal();

        if (isHighResolution && isPortrait) {
            this.prepareVWObservers();
        }
    }

    getProductFromRaw(rawProduct) {
        let productBaseInfo = this.helper.getProductBaseInfo(rawProduct);
        let productGender = this.helper.getProductGender(rawProduct);
        let productVariant = 'color' in productBaseInfo ? productBaseInfo.color : '';

        let product = {
            item_id:
                'id' in productBaseInfo
                    ? productBaseInfo.id
                    : 'id' in rawProduct
                    ? rawProduct.id.split('_')[0].trim()
                    : '',
            item_name: this.helper.formatString(rawProduct.nameEng),
            price: rawProduct.price.sales.value ? rawProduct.price.sales.value.toFixed(2) : '',
            quantity: '',
            item_brand: 'intimissimi',
            item_category: rawProduct.categoryPath,
            item_category2: productGender,
            item_category3: rawProduct.secondLevelCategory,
            item_category4: rawProduct.thirdLevelCategory,
            item_category5: rawProduct.fourthLevelCategory,
            item_list_name: rawProduct.GTMItemListName,
            item_list_id: rawProduct.GTMItemListId,
            item_variant: productVariant,
            size: productBaseInfo.size,
            item_on_sale: rawProduct.price.list ? 'Yes' : 'No',
            item_availability: rawProduct.available ? 'Available' : 'No',
            coupon:
                'promo' in productBaseInfo && productBaseInfo.promo
                    ? productBaseInfo.promo
                    : 'no_promotion',
            item_color: rawProduct.colorFamilyEng ? rawProduct.colorFamilyEng : '',
            item_sfcc: rawProduct.id,
            item_customization: rawProduct.uniqueIdentifier ? 'customized' : 'no',
            item_sustainable: rawProduct.isGreen ? 'sustainable_item' : 'classic_item',
            discount: rawProduct.price.list
                ? (rawProduct.price.list.value - rawProduct.price.sales.value).toFixed(2)
                : 0.0,
        };
        return this.helper.formatProductForAnalytics(product);
    }

    getPDPInfo() {
        let container = $('.analytics.product');
        return container.data();
    }

    pushPDPData() {
        let container = $('.analytics.product');
        if (container.length === 0) {
            // We are not in PDP
            return;
        }

        const obj = this.getPDPInfo();
        const GTMData = this.helper.getGtmData({
            item_id: obj.item_id,
            item_variant: obj.item_variant,
        });
        try {
            let URL_SP = new URLSearchParams(window.location.search);
            if (URL_SP.get('is_LS') === 'true') {
                GTMData.item_list_name = 'live_story';
                this.helper.storeGtmData(GTMData);
            }
        } catch (e) {}

        const item = this.helper.formatProductForAnalytics(obj);

        // Fix values for MEC-30160
        if (GTMData.item_list_name === 'not_available') {
            GTMData.item_list_name = 'listing'
        }

        if (GTMData.item_list_id === 'not_available') {
            GTMData.item_list_id = 'pdp'
        }

        Object.assign(item, GTMData);

        if (item.category === 'variation_master' || item.category === '') {
            item.category = localStorage.getItem('lastCategory');
        }
        localStorage.setItem('listtypeforcart', GTMData.item_list_name);

        const pushObject = {
            event: 'view_item',
            ss_event_id: Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            ecommerce: {
                currency: this.helperData.currency,
                item_list_name: item.item_list_name,
                item_list_id: item.item_list_id,
                items: [item]
            },
        };

        this.push({ecommerce: null});
        this.push(pushObject);
    }

    prepareVWObservers() {
        var _self = this;
        $('.videoWallButton').on('touchstart', function (e) {
            if ($(this).data('alreadyHandled')) {
                return;
            }
            $(this).data('alreadyHandled', 'true');
            _self.quickImpressionSender.pushMenuIconOnVW(
                $(this).closest('a').data('analytic-name')
            );
        });
        $('.cc-intMenu-category-container-vw .cc-intMenu-switchGender a').on('touchstart', function (e) {
            e.stopPropagation();
            _self.quickImpressionSender.pushMenuGenderVW(
                $(this).closest('a').data('target').split('_')[1]
            );
        });
        $('body').on('touchstart', '.analytics-menu-item', function (e) {
            if (!e.originalEvent) {
                return;
            }
            if ($(this).data('alreadyHandled')) {
                return;
            }
            $(this).data('alreadyHandled', 'true');
            if ($(e.currentTarget).hasClass('view-all-link')) {
                let category = $(e.currentTarget).data('href').toLowerCase().split('_');
                _self.quickImpressionSender.pushMenuCategoryVW(
                    'view_all',
                    category[1] + '-' + category[2],
                );
            } else {
                let menuId = $(this).data('category-id').split('_');
                let item =
                    menuId.indexOf('Type') > -1
                        ? menuId[menuId.indexOf('Type') + 1]
                        : menuId.slice(2).toString().replaceAll(',', ' ');
                let category =
                    _self.helper.formatString(menuId[1]) +
                    '-' +
                    _self.helper.formatString(menuId[2]);
                _self.quickImpressionSender.pushMenuCategoryVW(
                    _self.helper.formatString(item),
                    category,
                );
            }
        });

        const observer = new MutationObserver((mutations) => {
            const elementsToHandle = new Set();
            mutations.forEach((mutation) => {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node) => {
                        if ($(node).hasClass('kioskboard-key-enter')) {
                            elementsToHandle.add(node);
                        } else {
                            $(node)
                                .find('.kioskboard-key-enter')
                                .each(function () {
                                    elementsToHandle.add(this);
                                });
                        }
                    });
                }
                if (mutation.type === 'attributes' && $(mutation.target).hasClass('kioskboard-key-enter')) {
                    if ($(mutation.target).is(':visible')) {
                        elementsToHandle.add(mutation.target);
                    }
                }
            });

            elementsToHandle.forEach((element) => {
                handleKioskboardKeyEnter($(element));
            });
        });

        observer.observe(document.body, {
            childList: true,
            attributes: true,
            subtree: false,
            attributeFilter: ['class', 'style']
        });

        function handleKioskboardKeyEnter($elements) {
            $elements.each(function () {
                const $element = $(this);
                if (!$element.data('handlerInitialized')) {
                    $element.data('handlerInitialized', true);
                    $element.on('touchstart', function () {
                        let searchObject = $('.js-site-search');
                        if (searchObject.length) {
                            if (!searchObject.data('alreadyHandled')) {
                                searchObject.data('alreadyHandled', true);
                            }
                            let searchFields = $('.js-site-search form .js-site-search-inputSearch');
                            let searchTerm = searchFields[0]?.value || '';
                            if (searchTerm) {
                                _self.quickImpressionSender.pushSearchInteractionForVW(searchTerm.trim());
                            }
                        }
                    });
                }
            });
        }
    }

    // Header Impressions
    prepareHeaderObservers() {
        var _self = this;

        $('.analytic-header-icon').on('click touchstart', function (e) {
            if ($(this).data('alreadyHandled')) {
                return;
            }
            $(this).data('alreadyHandled', 'true');
            _self.quickImpressionSender.pushHeaderClickInteractionFor(
                $(this).data('analytic-name') || 'unknown'
            );
        });

        // Search
        let searchObject = $('.js-site-search');
        if (searchObject.length) {
            searchObject.find('form').submit(function (e) {
                let searchFields = $('.js-site-search form .js-site-search-inputSearch');
                let searchTerm = searchFields[0].value;
                _self.quickImpressionSender.pushSearchInteraction(searchTerm.trim());
            });
        }

        $('.js-menu-tab').on('click', function (e) {
            _self.quickImpressionSender.pushMainMenuClickInteraction(
                $(e.currentTarget).data('target').toLowerCase()
            );
        });
    }

    // Find your style
    preparePerfectBraObservers() {
        var _self = this;
        $('body').on('click', '.link-menu-section-box', function (e) {
            let target = $(e.currentTarget);
            let parent = target.parent('.menu-section-link');
            if (!(parent.find('.link-menu-section-box').length > 1)) {
                return;
            }
            if (parent.find('.link-menu-section-box').eq(1)[0] === target[0]) {
                _self.quickImpressionSender.pushPerfectBraModelInteraction('menu');
            }
        });
    }

    // Menu
    prepareMenuObservers() {
        var _self = this;

        $('body').on('click', '.analytics-menu-item', function (e) {
            if (!e.originalEvent) {
                return;
            }
            if ($(this).data('alreadyHandled')) {
                return;
            }
            $(this).data('alreadyHandled', 'true');

            if ($(e.currentTarget).hasClass('view-all-link')) {
                let category = $(e.currentTarget).data('href').toLowerCase().split('_');
                _self.quickImpressionSender.pushMenuItemClickInteractionFor(
                    'view_all',
                    category[1] + '-' + category[2]
                );
            } else {
                let menuId = $(this).data('category-id').split('_');
                let item =
                    menuId.indexOf('Type') > -1
                        ? menuId[menuId.indexOf('Type') + 1]
                        : menuId.slice(2).toString().replaceAll(',', ' ');
                let category =
                    _self.helper.formatString(menuId[1]) +
                    '-' +
                    _self.helper.formatString(menuId[2]);
                _self.quickImpressionSender.pushMenuItemClickInteractionFor(
                    _self.helper.formatString(item),
                    category
                );
            }
        });

        // Content asset menu item click
        $('.analytic-menu-content-link').on('click touchstart', function (e) {
            let name = _self.helper.formatString($(this).data('name'));
            _self.quickImpressionSender.pushMenuContentClickInteraction(name);
        });

        $('body').on('click', '.js-intMenu-footer a', function (e) {
            let voice = $(e.currentTarget).closest('.js-intMenu-footer').data('analytics-name');
            if (voice) {
                voice = _self.helper.formatString(voice);
            }
            // check if the page is being viewed on a mobile device and target the do-you-need-help-section
            if (
                !Foundation.MediaQuery.atLeast('large') &&
                $(e.currentTarget).closest('a').hasClass('spaceNeedHelp')
            ) {
                // insert function to be fired if the user is using a mobile device and is in the need help section
                return;
            }
            _self.quickImpressionSender.pushOutOfMenuClickInteraction(voice);
        });
    }

    // Search Filters
    prepareSearchObservers() {
        var _self = this;

        $('body').on('click', '.analytics-specialRef-chips', function (e) {
            let category = $(e.currentTarget).data('value-id')
                ? _self.helper.formatString($(e.currentTarget).data('value-id'))
                : 'view_all';
            _self.quickImpressionSender.pushSearchFilterSelectInteraction(
                category,
                ' ',
                'apply_to_category_filter'
            );
        });

        $('body').on('click', '.analytics-refinements-viewType', function (e) {
            _self.quickImpressionSender.pushSearchFilterSelectInteraction(
                'view_type',
                $(e.currentTarget).attr('id'),
                'select'
            );
        });

        $('body').on('click', '.analytics-search-filter', function (e) {
            let filterIsInUse = $(e.currentTarget).hasClass(
                'cc-plp-refinement-size-button_selected'
            );
            let category = $(e.currentTarget)
                .closest('.js-plp-refinements-body-accordionItem')
                .data('refinement');
            localStorage.setItem('horizontalFilter', true);
            _self.quickImpressionSender.pushSearchFilterSelectInteraction(
                category,
                $(e.currentTarget).data('value-id'),
                !filterIsInUse ? 'select' : 'remove'
            );
        });

        $('body').on('click', '.analytics-search-filter-boolean', function (e) {
            let filterIsInUse = $(e.currentTarget).is(':checked');
            let selection = _self.helper.formatString($(e.currentTarget).data('analytics-name'));
            _self.quickImpressionSender.pushSearchFilterSelectInteraction(
                _self.helper.formatString($(e.currentTarget).attr('name')),
                selection,
                filterIsInUse ? 'select' : 'remove'
            );
        });

        $('body').on('click', '.analytics-menu-externalRefinements', function (e) {
            let refinementsChecked = [];

            $('.js-plp-refineBar-menu-body_externalRefinement .js-plp-refineBar-menu-externalInput')
                .toArray()
                .forEach((item) => {
                    if ($(item).is(':checked')) {
                        refinementsChecked.push($(item).data('valueid'));
                    }
                });
            _self.quickImpressionSender.pushSearchFilterSelectInteraction(
                $(e.currentTarget).data('id'),
                refinementsChecked.join('-'),
                'apply'
            );
        });

        $('body').on('search:sort', function (e, data) {
            let orderType = $(e.target).data('id');
            _self.quickImpressionSender.pushSearchSortInteraction(orderType);
        });

        // 6.15 SEARCH - LIVE SUGGESTION RESULTS
        $('body').on('click', '.analytics-suggestions-products a, .analytics-suggested-words a', function (e) {
            let section = $(e.currentTarget).hasClass('cc-site-search-suggestions-words-link') ? 'suggested_term' : 'suggested_products';
            _self.quickImpressionSender.pushSearchLiveSuggestionResults(section, _self.helper.formatString($(e.currentTarget).data('analytics-phrase')));
        });

        // 6.16 SEARCH - CLICK TO CLOSE THE SEARCH BAR
        $('body').on('click', '.analytics-search-actions', function (e) {
            _self.quickImpressionSender.pushSearchOnCloseBtn(
                $(e.currentTarget).data('analytics-action')
            );
        });

        $('body').on('search:clearInput', function (e) {
            _self.quickImpressionSender.pushSearchOnCloseBtn('clear');
        });
    }

    // Newsletter
    prepareNewsletterObservers() {
        var _self = this;
        $('body').on('click', '#submitNewsletter', function (e) {
            let result = 'success';
            let errorEmailOne = $('#newsletter-Email');
            if (!errorEmailOne.parsley().isValid() && errorEmailOne.val().length > 0 ) {
                result = 'error';
                _self.quickImpressionSender.pushNewsletterError('step_1', 'wrong_email');
            }
            _self.quickImpressionSender.pushNewsletterStep1('footer', 'step1');
        });

        $('body').on('click', '.newsletter-popup__content .close', function (e) {
            _self.quickImpressionSender.pushNewsletterStep1('footer', 'exit');
        });

        $('body').on('click', '.js-proceedStepZeroDesktop', function (e) {
            let result = 'error';
            let errorEmail = $('#email').parsley().isValid();
            if (errorEmail) {
                result = 'success';
            }
            else {
                _self.quickImpressionSender.pushNewsletterError('step_2', 'wrong_email');
            }
            _self.quickImpressionSender.pushNewsletterStep2('footer', 'unselected', result);
        });

        $('body').on('newsletter:stepOnePointTwo', function (e, {title}) {
            const genderValues = {
                1: 'mr',
                2: 'mrs',
                3: 'other',
                4: 'prefer_not_to_say',
            };
            let result = 'error';
            let errorGender = document.getElementById('newsletterGender').value;
            let errorPrivacy = $('#newspromotions').is(':checked');
            let possibleErrors = [['unselected_gender', errorGender.length > 4], ['unselected_privacy', !errorPrivacy]];
            let triggeredErrors = possibleErrors.filter(e => e[1]).map(e => e[0]);
            let joinedErrors = triggeredErrors.join('_and_');
            if (errorGender > 0 && errorPrivacy) {
                result = 'success';
            }
            else {
                _self.quickImpressionSender.pushNewsletterError('step_2', joinedErrors);
            }
            _self.quickImpressionSender.pushNewsletterStep2('footer', genderValues[title], result);
        });

        $('body').on('newsletter:unsubscribe', function () {
            if (!$('#phone-number-cell').length) {
                _self.quickImpressionSender.pushNewsletterUnsubscribe();
            }
        });

        // Trigger after user lands in Newsletter-Confirm via email verification
        if ($('.page').data('action') === 'Newsletter-Confirm') {
            let result = 'success';
        if (document.getElementsByClassName('js-newsletterSuccess').length < 1) {
            result = 'error';
            _self.quickImpressionSender.pushNewsletterError('step_3', 'invalid_confirmation_link_or_service_error');
        }
            _self.quickImpressionSender.pushNewsletterStep3(result);
        }
    }

    // Contact Us
    handleContactUs() {
        var _self = this;
        $('body').on('submit', 'form#form-contact', function (e) {
            if (!e.currentTarget.checkValidity()) {
                return;
            }
            let notRobot = grecaptcha && grecaptcha.getResponse().length !== 0;
            if (notRobot) {
                _self.quickImpressionSender.pushContactUsInteraction(
                    $('#web-form-request-questions').find('option:selected').attr('id')
                );
            }
        });
    }

    // Unsubscribe phone
    handleUnsubscribePhone() {
        var _self = this;
        $('body').on('analytics:phoneUnsubscribe', function () {
            _self.quickImpressionSender.pushUnsubscribePhone();
        });
    }

    // Wishlist
    observeWishlistChanges() {
        var _self = this;
        $('body').on('wishlist:add', function (e, data) {
            _self.quickImpressionSender.pushAddToWishlistInteraction(data.sku, data.sender);
        });

        $('body').on('wishlist:remove', function (e, data) {
            _self.quickImpressionSender.pushRemoveFromWishlistInteraction(data.sku);
        });

        // remove product by clicking the heart in pdp
        $('body').on('wishlist:changedSuccessfully', function (e, {isAdding, pid}) {
            if (!isAdding) {
                _self.quickImpressionSender.pushRemoveFromWishlistInteraction(
                    _self.helper.getFormatSku(decodeURI(pid))
                );
            }
        });
    }

    // Footer & Prefooter
    observeFooterChanges() {
        var _self = this;
        // Social Icons
        $('.analytic.analytic-social-icon-share').on('click', function (e) {
            let socialName = $(this).data('name');
            _self.quickImpressionSender.pushSocialClickInteractionFooter(socialName);
        });

        $('.analytics-prefooter').on('click', function (e) {
            let cta = $(e.currentTarget).data('name');
            if (cta) {
                _self.quickImpressionSender.pushPreFooterCtaClick(_self.helper.formatString(cta));
            }
        });

        $('.analytic-footer-icon-text').on('click', function (e) {
            let name = _self.helper.formatString($(this).data('name'));
            _self.quickImpressionSender.pushFooterLinkClickInteraction(
                'icon_text',
                name,
                'prefooter'
            );
        });

        $('.analytic-footer-text').on('click', function (e) {
            let name = _self.helper.formatString($(this).data('name'));
            let category = _self.helper.formatString(
                $(this).closest('.cc-footerLinks-content_box').data('analytics-category')
            );
            // check if the page is being viewed on a mobile device and target the do-you-need-help-section
            if (!Foundation.MediaQuery.atLeast('large') && $(this).hasClass('spaceNeedHelp')) {
                // insert function to be fired if the user is using a mobile device and is in the need help section
                return;
            }
            _self.quickImpressionSender.pushFooterLinkClickInteraction('text', name, category);
        });
    }

    // Products
    observeProductChanges() {
        var _self = this;
        const lang = $('html').attr('lang');

        $('body').on('click', '.slick-arrow', function (e) {
            let sku = $(e.currentTarget).closest('.js-prodTile').data('pid');
            _self.quickImpressionSender.pushProductChangeImageInteraction(sku);
        });

        $('body').on('product:didChangeColor', function (e, data) {
            data.sku = data.sku ? data.sku.replace(/\s+/g, '_') : '';
            data.promotionType = $('.analytics.product').data('coupon') === 'no_promotion' ? 'no_promo' : 'promo';
            data.sku = _self.helper.getFormatSku(data.sku);
            data.color = data.sku.split('_')[1];

            if (data.sku && data.promotionType) {
                _self.quickImpressionSender.pushProductChangeColorInteraction(data);
            }
        });

        $('body').on('product:didChangeColorFromCart', function (e, data) {
            data.promotionType = data.promotionType === 'no_promotion' ? 'no_promo' : 'promo';
            data.sku = _self.helper.getFormatSku(data.sku);
            _self.quickImpressionSender.pushProductChangeColorInteraction(data);
        });

        $('body').on('product:didChangeColorForProductDetails', function (e, data) {
            // Launch ProductDetails event too in PDP
            var item = _self.getProductFromRaw(data);

            if (item) {
                item.quantity = parseInt($('.js-quantity-value').html());
                var list = 'listing';
                try {
                    let URL_SP = new URLSearchParams(window.location.search);
                    list =
                        URL_SP.get('is_LS') === 'true'
                            ? 'live_story'
                            : localStorage.getItem('listtype');
                } catch (e) {}

                try {
                    item.index = parseInt(localStorage.getItem('lastClickedPosition')) || 0;
                } catch (e) {
                    item.index = 0;
                }

                if (data.isFreeGist === true) {
                    item.discount = item.price;
                    item.price = '0.00';
                }

                const obj = _self.getPDPInfo();
                const GTMData = _self.helper.getGtmData({
                    item_id: obj.item_id,
                    item_variant: obj.item_variant,
                });
                
                Object.assign(item, GTMData);

                let pushObject = {
                    event: 'view_item',
                    ss_event_id: Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
                    ecommerce: {
                        currency: _self.helperData.currency,
                        'item_list_name': list,
                        'item_list_id': _self.helper.getListId(),
                        items: [item]
                    },
                };
                _self.push({ecommerce: null});
                _self.push(pushObject);
            }
        });


        $('body').on('product:didChangeSize', function (e, data) {
            if ($('.pdp-size-box').hasClass('alreadyOpened')) {
                $('.pdp-size-box').removeClass('alreadyOpened');
            }
            data.promotionType = $('.analytics.product').data('coupon') === 'no_promotion' ? 'no_promo' : 'promo';
            data.sku = _self.helper.getFormatSku(data.sku);

            if (data.sku && data.size && data.promotionType) {
                _self.quickImpressionSender.pushProductChangeSizeInteraction(data);
            }
        });

        $('body').on(
            'click',
            '.linkModalFindYourSize, .js-linkModalFindYourSizePlp, .js-linkModalFindYourSize',
            function (e, data) {
                let sku = decodeURIComponent(
                    $(e.currentTarget).closest('.product-detail').data('variant-pid')
                );
                _self.quickImpressionSender.pushProductStyleAndGuidesClickInteraction(
                    sku.toLowerCase()
                );
            }
        );

        $('body').on(
            'click',
            '#calculateFromModalPdp, .analytics-linkModalFindYourSize a',
            function (e) {
                let sku = _self.helper.getFormatSku(
                    decodeURI($('.product-detail').data('variant-pid'))
                );
                if ($(e.target).attr('id') === 'calculateFromModalPdp') {
                    _self.quickImpressionSender.pushProductDetailPageGuideInteraction(
                        'calculate',
                        sku
                    );
                } else {
                    _self.quickImpressionSender.pushProductDetailPageGuideInteraction('view', sku);
                }
            }
        );

        $('body').on('accordion:breakpoint-all-expanded', function (e, element) {
            if (element && $(element).hasClass('accordion-analytics')) {
                let action = 'expand';
                let info = $(element).data('analytics-info');
                let sku = _self.helper.getFormatSku(
                    $(element).closest('.product-detail').data('pid')
                );
                _self.quickImpressionSender.pushProductInformationalMenuChange(action, info, sku);
            }
        });

        $('body').on('click', '.accordion-analytics, .analytics-productDetail', function (e) {
            let action = $(e.currentTarget).hasClass('accordion-analytics') ? 'expand' : 'click';
            let info = $(e.currentTarget).data('analytics-info');
            let sku = _self.helper.getFormatSku(
                $(e.currentTarget).closest('.product-detail').data('pid')
            );
            _self.quickImpressionSender.pushProductInformationalMenuChange(action, info, sku);
        });

        $('body').on('click', '.productImageCarouselItem', function (e, data) {
            var sku = $(e.currentTarget).closest('.product-detail').data('variant-pid');
            _self.quickImpressionSender.pushProductZoomInteraction(
                _self.helper.getFormatSku(decodeURI(sku))
            );
        });

        $('body').on('find-in-store-size-select-btn:click', function (_, data) {
            let productName = $('.analytics.product').data().name || '';
            let analyticsSku = $('.product-detail').data('variant-pid') || '';
            let size = $('button.size-selector.selected').data('attrValue') || '';
            let sizeList = [];
            $('button.size-selector.selected').each(function (el, ind) {
                sizeList.push($(ind).data('attr-value'));
            });
            let sizeListPdp = sizeList.join('-');

            productName = productName.replace(/\s\s+/g, ' ').split(' ').join('_');
            let isSoldout = $('.js-intProductDetail').hasClass('js-isSoldOut');
            let isComingSoon =
                $('.product-content-size input[type="radio"][data-iscomingsoon="true"]').length > 0;
            let sizeNotAbailableNotifyMe =
                $('.product-content-size input[type="radio"][data-attr-value="' + size + '"]')
                    .closest('label')
                    .find('div.notifyMe').length > 0;
            let sizeNotAvailableNoNotifyMe = $(
                '.product-content-size input[type="radio"][data-attr-value="' + size + '"]'
            ).prop('disabled');
            let notAvailable =
                isSoldout || isComingSoon || sizeNotAbailableNotifyMe || sizeNotAvailableNoNotifyMe;
            $('body').trigger('soldout:availability', {
                productName: productName,
                size: sizeListPdp,
                sku: analyticsSku,
                isNotAvailable: notAvailable,
            });
        });

        $('body').on('click', '.size-list-item', function (e) {
            e.stopPropagation();
        });

        $('body').on('product:selectSize', function (e, data) {
            var sku = $(data).closest('.product-detail').length
            ? $(data).closest('.product-detail').data('pid')
            : ($(data).closest('.js-customizePage').length
            ? $(data).closest('.js-customizePage').data('pid') :
            $(data).closest('.js-prodTile').data('pid'));
            _self.quickImpressionSender.pushSelectSize(sku);
        });

        $('.cc-sizeBox-openPanel.js-sizeBox-openPanel').on('click', function (e) {
            if (!$(e.currentTarget).parent().hasClass('alreadyOpened')) {
                $(e.currentTarget).parent().addClass('alreadyOpened');
                var sku = $(e.target).closest('.product-detail').length
                ? $(e.target).closest('.product-detail').data('pid')
                : ($(e.target).closest('.js-customizePage').length 
                ? $(e.target).closest('.js-customizePage').data('pid') :
                $(e.target).closest('.js-prodTile').data('pid'));
                _self.quickImpressionSender.pushSelectSize(sku);
            } else {
                $(e.currentTarget).parent().removeClass('alreadyOpened');
            }
        });

        $('.cc-sizeBox-openPanel.js-sizeBox-openPanel').on('click', function (e) {
            let parent = $(e.currentTarget).parent();
            if (!parent.hasClass('analytics-sizeBox-pdp')) {
                return;
            }
            if (!parent.hasClass('alreadyOpened')) {
                parent.addClass('alreadyOpened');
                var sku = $(e.target).closest('.product-detail').length
                    ? $(e.target).closest('.product-detail').data('pid')
                    : ($(e.target).closest('.js-customizePage').length 
                    ? $(e.target).closest('.js-customizePage').data('pid') :
                    $(e.target).closest('.js-prodTile').data('pid'));
                _self.quickImpressionSender.pushSelectSize(sku);
            } else {
                parent.removeClass('alreadyOpened');
            }
        });

        $('body').on('click', '.personalizeButtonAnalytics', function (e, data) {
            let sku = $(e.currentTarget).closest('.product-detail').data('pid');
            let productName = $('.analytics.product').data().name || '';
            _self.quickImpressionSender.pushCustomizeProduct(productName, sku);
        });

        $('body').on('customize:actions', function (e, data) {
            let sku = _self.helper.getFormatSku(data.pid);
            let action = data.action;
            _self.quickImpressionSender.pushCustomizeProductAction(action, sku);
        });

        $('body').on('storeLocator:searchWithZipCodePDP', function (e, data) {
            var action = 'search_for_products_in_the_store';
            let sku = data.sku;
            let size = data.size ? data.size : null;
            _self.quickImpressionSender.pushFindStoreFindInteraction(
                $('#input-text-woosmap-findinstore').val(),
                sku,
                action,
                size
            );
        });

        $('body').on('storeLocator:searchWithZipCodeGeo', function (e, data) {
            var action = 'search_for_products_in_the_store';
            let sku = data.sku;
            let size = data.size ? data.size : null;
            _self.quickImpressionSender.pushFindStoreGeolocationImpression(
                $('.js-store-city').eq(0).html(),
                sku,
                action,
                size
            );
        });

        $('body').on('storeLocator:searchWithZipCodeGeoCheckout', function (e, data) {
            var action = 'shipping_method';
            let sku = data.sku
                .split(',')
                .map((e) => {
                    return _self.helper.getFormatSku(e);
                })
                .join('-');
            let size = data.size ? data.size : '';
            _self.quickImpressionSender.pushFindStoreGeolocationImpressionCheckout(
                $('.js-store-city').eq(0).html().replace(',', ''),
                sku,
                action,
                size
            );
        });

        $('body').on('storeLocator:searchWithZipCodeGeoCheckoutCity', function (e, data) {
            if ($('.page').data('action') === 'Order-Details') {
                // Flow when the user is returning a product and searches for stores
                $('body').trigger('analytics:refundFindYourStore', {
                    'action': '',
                    'where': data.name 
                });
                return;
            }
            var action = 'shipping_method';
            let name = data.name;
            let size = null;
            var skuList = [];
            $('.checkout-product').each(function (el, ind) {
                if ($(ind).data('item_sfcc') !== 'PERS_PROD') {
                    skuList.push(_self.helper.getFormatSku($(ind).data('item_sfcc')));
                }
            });

            let skuListPdp = skuList.join('-');
            _self.quickImpressionSender.pushFindStoreFindInteraction(
                name,
                skuListPdp,
                action,
                size
            );
        });

        $('body').on('click', '.analyticsFreeShipping', function (e, data) {
            let cta = $('.analyticsFreeShipping').text().trim();
            let action = 'shipping_pdp';
            _self.quickImpressionSender.pushLoyaltyCta(action, cta);
        });

        $('body').on('click', '.analyticsPromoMore', function (e, data) {
            let text = $('.promo-more-info').text().trim();
            _self.quickImpressionSender.pushPromoAncor(text);
        });

        $('body').on('product:buyLookBtnAnalytics', function (e, data) {
            var sku = $('div.product-wrapper').data('variant-pid') || '';
            _self.quickImpressionSender.pushShopTheLook(sku);
        });

        $('body').on('click', '.prevAnalytics, .nextAnalytics', function (e) {
            let sku = $(e.currentTarget).closest('.product-detail-keeper').data('variant-pid');
            _self.quickImpressionSender.pushProductChangeImageInteraction(sku);
        });

        $('body').on('afterchange', '.slick-track', function (e, data) {
            let sku = $('div.product-wrapper').data('variant-pid') || '';
            _self.quickImpressionSender.pushProductChangeImageInteraction(decodeURI(sku));
        });

        $('body').on('afterChange', '.primary-images.slick-slider', function (e) {
            if (!Foundation.MediaQuery.atLeast('large')) {
                let sku = $('div.product-wrapper').data('variant-pid') || '';
                _self.quickImpressionSender.pushProductChangeImageInteraction(decodeURI(sku));
            }
        });

        $('body').on(
            'click',
            '#add-to-cart-multipack-cta-pdp, .cart-page #complete-your-promo',
            function (e) {
                let location = $('.page').data('action') === 'Product-Show' ? 'pdp' : 'cart';
                let name =
                    location === 'pdp'
                        ? $('.analytics-pdp-promo-msg').data('promotion-id')
                        : $(e.currentTarget).data('promotion-id');
                _self.quickImpressionSender.pushCompleteThePromoInteraction(
                    _self.helper.formatString(name),
                    _self.helper.formatString(location)
                );
            }
        );
        // 6.149 FIND OUT MORE (ONLY FRANCE COUNTRY)
        $('body').on('click', '.js-analytics-traceability', function (e) {
            _self.quickImpressionSender.pushFindOutMoreTraceabilityInteraction();
        });

        $('body').on('click', '.analytics-searchNearestStore', function (e) {
            let sku = $(e.currentTarget).closest('.js-intProductDetail').data('pid');
            if (sku) {
                _self.quickImpressionSender.pushSearchNearestStorePDP(_self.helper.getFormatSku(sku));
            }
        });
    }

    observeSoldOutPopupChanges() {
        var _self = this;

        $('body').on('soldout:notify', function (e, {availability, productName, size, sku}) {
            productName = _self.helper.formatString(productName);
            sku = _self.helper.getFormatSku(decodeURIComponent(sku));
            _self.quickImpressionSender.pushNotifyMeSoldOutSize(
                availability,
                productName,
                size,
                sku
            );
        });

        $('body').on('soldout:popupActions', function (e, {cta, productName, size, sku}) {
            productName = _self.helper.formatString(productName);
            sku = _self.helper.getFormatSku(decodeURIComponent(sku));
            _self.quickImpressionSender.pushActionsOnTheNotifyMePopup(cta, productName, size, sku);
        });

        $('body').on(
            'soldout:availability',
            function (e, {productName, size, sku, isNotAvailable}) {
                sku = _self.helper.getFormatSku(decodeURIComponent(sku));
                productName = _self.helper.formatString(productName);
                _self.quickImpressionSender.pushCheckAvailabilitySoldOutSize(
                    productName,
                    size,
                    sku,
                    isNotAvailable
                );
            }
        );

        $('body').on('soldout:availabilityChangeSize', function (e, data) {
            _self.quickImpressionSender.pushCheckAvailabilityChangeSize(
                data.productName,
                data.size,
                decodeURIComponent(data.sku)
            );
        });

        $('body').on('product-find-in-store:click', function (e, data) {
            if (data.isDispo) {
                return;
            }
            let productName = $('.analytics.product').data().name || '';
            let id = $('.analytics.product').data('item_sfcc');
            let size = $('[data-attr="size"] input:checked').data('attrValue') || '';
            productName = productName.replace(/\s\s+/g, ' ').split(' ').join('_');
            var isSoldout = $('.js-intProductDetail').hasClass('js-isSoldOut');
            var isComingSoon =
                $('.product-content-size input[type="radio"][data-iscomingsoon="true"]').length > 0;
            if (isSoldout || isComingSoon) {
                _self.quickImpressionSender.pushFindInStoreForNotAvailableProductInteraction(
                    id,
                    productName,
                    size
                );
            } else {
                _self.quickImpressionSender.pushFindInStoreForAvailableProductInteraction(
                    id,
                    productName,
                    size
                );
            }
        });

        $('body').on('click', '.js-add-to-cart.soldout-add', function () {
            let id = $('div.product-wrapper').data('variant-pid') || '';
            _self.quickImpressionSender.pushNotfyMeCtaClickSoldout(id);
        });
    }

    prepareScalaPayObservers() {
        var _self = this;

        $('body').on('scalaPay:openModal', function (e, data) {
            _self.quickImpressionSender.pushScalaAndKlarnPayModalInteraction('scalapay', data);
        });
    }

    prepareKlarnaObservers() {
        var _self = this;

        $('body').on('klarnaPay:openModal', function (e) {
            let currentPage =
                $('.page').data('action') === 'Product-Show' ? 'product_page' : 'shopping_bag';
            _self.quickImpressionSender.pushScalaAndKlarnPayModalInteraction('klarna', currentPage);
        });
    }

    prepareAfterpayObservers() {
        var _self = this;

        $('body').on('afterpay:openModal', function (e, data) {
            _self.quickImpressionSender.pushAfterpayModalInteraction(data);
        });
    }

    prepareGiftcardObservers() {
        var _self = this;

        $('body').on('checkout:giftcardCheckBalance', function (e, data) {
            _self.quickImpressionSender.giftcardCheckBalance(data);
        });
    }

    observeContentChanges() {
        var _self = this;

        $('body').on('click', '.analytics-content-button', function (e) {
            let action = _self.helper.formatString($(this).data('name'));
            _self.quickImpressionSender.pushActionOnTheBottoms(action);
        });
    }

    observeOrderChanges() {
        var _self = this;

        $('body').on('order:cancel', function (e, data) {
            _self.quickImpressionSender.pushCancelYourOrderInteraction(data.orderId);
        });

        $('body').on('order:cancelInteraction', function (e, data) {
        let action = _self.helper.formatString(data.action);
            _self.quickImpressionSender.pushCancelYourOrderInteractionAction(
                data.orderId,
                action
            );
        });
    }

    // Splash Page
    observeSplashPageChanges() {
        var _self = this;

        $('body').on('click', '.analytics-gender', function (e) {
            let gender = _self.helper.formatString($(this).data('name')); 
            _self.quickImpressionSender.pushSplashPageChanges(gender);
        });
    }

    // Made In
    observeMadeInClick() {
        var _self = this;

        $('body').on('click', '.js-analytics-made-in', function (e) {
            let event = $(this).data('plant').split(' ').join('_').toLowerCase();
            let plant = event.split(',').join('');
            let sku = decodeURIComponent($('.product-detail').data('pid'));
            sku = _self.helper.getFormatSku(sku);

            let pushObject = {
                event: 'GAevent',
                ss_event_id: Date.now()
                    .toString()
                    .concat(Math.random().toString(36).substring(1, 13)),
                eventID: '81',
                eventname: 'made_in',
                action: 'click_word',
                text: plant,
                product_id: sku,
            };

            _self.push(pushObject);
        });

        $('body').on('click', '.js-analytics-modal-cta', function (e) {
            let action = $(this).data('action').split(' ').join('_').toLowerCase();
            let plant = $(this).data('fabric').split(',').join('_').toLowerCase();

            let pushObject = {
                event: 'GAevent',
                ss_event_id: Date.now()
                    .toString()
                    .concat(Math.random().toString(36).substring(1, 13)),
                eventID: '82',
                eventname: 'made_in',
                action: action,
                text: plant,
            };

            _self.push(pushObject);
        });

        $('body').on('click', '.read-more', function (e) {
            _self.quickImpressionSender.pushReadTheWholeInterview();
        });

        $('body').on('click', '.plant-box', function (e) {
            let plant = e.currentTarget.innerText.split('\n').reverse().join('_').toLowerCase();
            _self.quickImpressionSender.pushMadeInPlantInteraction(plant);
        });

        $('body').on('click', '.thumb', function (e) {
            var project = $(this).find('.thumbLabel').data('english-title');
            _self.quickImpressionSender.pushMadeInTheProjectsInteraction(
                project.split(' ').join('_').toLowerCase()
            );
        });
    }

    handleBuyGiftCard() {
        var _self = this;

        $('body').on('click', '.ctaButtonBuyGC', function (e) {
            var eventId = Date.now() + '.' + Math.random().toString(36).slice(2);
            var ctaName = 'shop_for_' + $(this).data('category').toLowerCase();
            _self.quickImpressionSender.pushHandleGiftCard(eventId, ctaName);
        });
    }

    // Smart Gift
    handleSmartGift() {
        var _self = this;
        $('body').on('analytics:addSmartGift', function (e, data) {
            var formattedSku = _self.helper.getFormatSku(data.sku);
            _self.quickImpressionSender.pushSmartGift(formattedSku, data.name);
        });
        $('body').on('analytics:smartGiftBasketButtons', function (e, data) {
            var formattedSkus = _self.helper.formatSkus(data.skus);
            _self.quickImpressionSender.pushSmartGiftBasketInteraction106(
                data.action,
                formattedSkus,
                data.quantity
            );
        });
        $('body').on('analytics:smartGiftBasketRemoveProduct', function (e, data) {
            var productName = _self.helper.formatString(data.productName);
            var formattedSku = _self.helper.getFormatSku(data.sku);
            _self.quickImpressionSender.pushSmartGiftBasketInteraction107(
                productName,
                formattedSku
            );
        });
        $('body').on('analytics:smartGiftBasketIcon', function () {
            let location = '';
            if ($('.page').data('action') === 'Product-Show') {
                location = 'product_page';
            } else {
                location = 'listing_page';
            }
            _self.quickImpressionSender.pushSmartGiftBasketInteraction108(location);
        });
        $('body').on('analytics:smartGiftMoreInfo', function () {
            _self.quickImpressionSender.pushSmartGiftMoreInfo();
        });
    }

    // video in PDP
    handleVideoInteraction() {
        var _self = this;
        $('body').on('analytics:videoInteraction', function (e, data) {
            let nameEng = _self.helper.getProductNameEngFromPdp();
            let sku = _self.generateAnalyticsSku(data.fullPageLoad);
            if (data.action === 'auto_play' || data.action === 'play') {
                _self.quickImpressionSender.pushVideoPlayEvent(data.action, nameEng, sku);
            } else if (data.action === 'pause') {
                _self.quickImpressionSender.pushVideoPauseEvent(nameEng, sku);
            } else if (data.action === 'view25') {
                _self.quickImpressionSender.pushVideo25Event(nameEng, sku);
            } else if (data.action === 'view50') {
                _self.quickImpressionSender.pushVideo50Event(nameEng, sku);
            } else if (data.action === 'view75') {
                _self.quickImpressionSender.pushVideo75Event(nameEng, sku);
            } else if (data.action === 'full_view') {
                _self.quickImpressionSender.pushFullVideoEvent(nameEng, sku);
            }
        });
    }

    handleRatingAndReviewsPdp() {
        const _self = this;
        $('body').on('analytics:ratingAndReviewsPdp', function (e, data) {
            let sku = _self.generateAnalyticsSku();
            _self.quickImpressionSender.pushRatingAndReviewsInteraction101(
                data.action,
                data.word,
                sku
            );
        });
    }

    handleRatingAndReviewsForm() {
        const _self = this;
        $('body').on('analytics:ratingAndReviewsFormGuidelines', function () {
            let productName = $('.tingle-modal #review-popup .product-name').data('analytics-name');
            let formattedName = _self.helper.formatNameForAnalytics(productName);
            let sku = $('.tingle-modal #review-popup #reviewSku').val();
            let formattedSku = _self.helper.getFormatSku(sku);
            _self.quickImpressionSender.pushRatingAndReviewsInteraction102(
                formattedName,
                formattedSku
            );
        });
        $('body').on('analytics:ratingAndReviewsFormSubmit', function () {
            let overallRating = $(
                '.tingle-modal #review-popup .stars .review-star-wrapper svg path[style*="0"'
            ).length;
            let sizeRating = $('.tingle-modal #review-popup .review-radio-size:checked').data(
                'analytics-name'
            );
            let qualityRating = $('.tingle-modal #review-popup .review-radio-quality:checked').data(
                'analytics-name'
            );
            let comfortabilityRating = $(
                '.tingle-modal #review-popup .review-radio-comfort:checked'
            ).data('analytics-name');
            let sku = $('.tingle-modal #review-popup #reviewSku').val();
            let formattedSku = _self.helper.getFormatSku(sku);
            _self.quickImpressionSender.pushRatingAndReviewsInteraction103(
                overallRating,
                sizeRating,
                qualityRating,
                comfortabilityRating,
                formattedSku
            );
        });
        $('body').on('analytics:ratingAndReviewsFormSubmitted', function (e, data) {
            _self.quickImpressionSender.pushRatingAndReviewsInteraction104(data.action);
        });

        $('body').on('click', '.analytics-reviews-btn', function (e) {
            let category = $('.analytics.product').data('category').split('/')[2];
            let sku = _self.helper.getFormatSku(decodeURI($('.product-detail').data('variant-pid')));
            _self.quickImpressionSender.pushReviewsButtonOnPdpInteraction(category, sku);
        });

        $('body').on('click', '#ratingsReviewsSection .tt-c-review-toolbar button.tt-o-button', function (e) {
            let action = $(e.currentTarget).find('.tt-c-review-toolbar__likes-number').length ? 'like' : 'dislike';
            let stars = $(e.currentTarget).closest('.tt-c-review').find('.tt-o-icon--star--full').length;
            let sku = _self.helper.getFormatSku(decodeURI($('.product-detail').data('variant-pid')));
            _self.quickImpressionSender.pushLikeDislikeToReview(action, stars + '_stars', sku);
        });
    }

    prepareNeedHelpObservers() {
        var _self = this;

        let pageType = _self?.helperData?.pageType;

        $('body').on('click', '#esw-fab', function (e) {
            if ($(e.currentTarget).attr('aria-expanded') === 'true') {
                _self.quickImpressionSender.pushBubbleClickInteraction(pageType);
            }
        });

        $('body').on('click', '.cta-embeddedserviceconfig', function () {
            _self.quickImpressionSender.pushESWInteraction('chat', pageType);
        });

        $('body').on('click', '.cta-phone', function () {
            _self.quickImpressionSender.pushESWInteraction('call_number', pageType);
        });

        $('body').on('click', '.cta-customurl', function (e) {
            if (
                $(e.currentTarget).find('.cta-link-customurl').attr('href').includes('contactform')
            ) {
                _self.quickImpressionSender.pushESWInteraction('send_an_email', pageType);
            } else if (
                $(e.currentTarget).find('.cta-link-customurl').attr('href').includes('orderstatus')
            ) {
                _self.quickImpressionSender.pushESWInteraction(
                    'follow_your_order_or_return',
                    pageType
                );
            } else if (
                $(e.currentTarget).find('.cta-link-customurl').attr('href').includes('general-info')
            ) {
                _self.quickImpressionSender.pushESWInteraction('leave_a_feedback', pageType);
            }
        });

        $('body').on('analytics:privacyPopUP', function (e, data) {
            var privacyNews = data.privacyNews;
            var privacyCustomNews = data.privacyCustomNews;
            _self.quickImpressionSender.pushPrivacyPolicyPopUP(
                data.action,
                privacyNews,
                privacyCustomNews
            );
        });
    }

    prepareEcoChoiceObservers() {
        var _self = this;

        let user = 'guest';
        if (_self?.helperData?.frequentlyUser) {
            user = 'frequently_user';
        }

        let refundPageselector = '.js-label-refund .info-icon-tooltip.eco-green';
        refundPageselector += ',.return-in-store-enabled .info-icon-tooltip.eco-green';
        refundPageselector += ',#returnMethodDiv .info-icon-tooltip.eco-green';
        $('body').on('click', refundPageselector, function (e, data) {
            _self.quickImpressionSender.pushEcoChoiceClick('refund', user);
        });

        $('body').on(
            'mouseenter',
            '.tingle-modal.express-button-modal .info-icon-tooltip.eco-green',
            function (e, data) {
                _self.quickImpressionSender.pushEcoChoiceClick('popup', user);
            }
        );

        $('body').on(
            'mouseenter',
            '.shipping-section .info-icon-tooltip.eco-green',
            function (e, data) {
                _self.quickImpressionSender.pushEcoChoiceClick('checkout', user);
            }
        );
    }

    prepareTrackYourOrderObservers() {
        var _self = this;

        $('body').on('submit', '#form-order-status', function (e) {
            let transactionID = $(e.target).find('#ordernumberfororder').val();
            _self.quickImpressionSender.pushTrackYourOrder(transactionID);
        });
    }

    preparePersonalAreaNavigationOrderSectionObservers() {
        var _self = this;

        $('body').on('click', '.analytics-orders-actions', function (e) {
            let orderType;
            
            if ($('.page').data('action') === 'Order-Details') {
                orderType = _self.helper.checkPage('e-commerce') ? 'online_orders' : 'in_store_orders';
            } else {
                orderType = $('.js-accountPage-detailsOrderTabs.current').data('analytic-order-type')
            }

            _self.quickImpressionSender.pushPersonalAreaNavigationOrderSection($(e.currentTarget).data('analytic-name'), orderType);
        });
    }
    cookiePolicyObservers () {
        var _self = this;

        $('body').on('click', '.ot-close-link', function () {
            _self.quickImpressionSender.pushCookieBanner('close');
        });

        $('body').on('click', '#onetrust-policy-text a:not(.ot-sdk-show-settings)', function () {
            _self.quickImpressionSender.pushCookieBanner('cookie_policy');
        });

        $('body').on('click', '.ot-sdk-show-settings', function () {
            _self.quickImpressionSender.pushCookieBanner('cookie_settings');
        });

        $('body').on('click', '#onetrust-accept-btn-handler', function () {
            _self.quickImpressionSender.pushCookieBanner('accept_all_cookies');
        });
    }

    replaceTagsPrivacyConsentModal () {
        const _self = this;
        const targetNode = document.body;
        const config = { childList: true, subtree: true };

        const callback = function (mutationsList, observer) {
            let isBannerChanged = false;
            let isPrivacyConsentChanged = false;

            for (const mutation of mutationsList) {
                if (mutation.type !== 'childList') {
                    continue;
                }

                const modalPrivacyConsent = $('#onetrust-pc-sdk');
                if (modalPrivacyConsent.length) {
                    modalPrivacyConsent.find('h1, h2, h3, h4, h5, h6').each((idx, element) => {
                        _self.replaceElementIfExists($(element));
                    });
                    isPrivacyConsentChanged = true;
                }

                const modalBanner = $('#onetrust-banner-sdk');
                if (modalBanner.length) {
                    modalBanner.find('h1, h2, h3, h4, h5, h6').each((idx, element) => {
                        _self.replaceElementIfExists($(element));
                    });
                    isBannerChanged = true;
                }
            }

            if (isBannerChanged && isPrivacyConsentChanged) {
                observer.disconnect();
            }
        };

        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
    }

    replaceElementIfExists (oldElement, newTag = 'div') {
        if (oldElement && oldElement.length) {
            const newElement = $(`<${newTag}>`);
            newElement.html(oldElement.html());

            $.each(oldElement.prop('attributes'), function () {
                $(newElement).attr(this.name, this.value);
            });

            oldElement.replaceWith(newElement);
        }
    }
}

const manager = new AnalyticsManager();
module.exports = manager;
